import { Component, type ReactNode } from 'react';

// Catches render-time crashes (e.g. an unexpected upstream shape rendered as a React child) so
// a single page degrades to a readable message instead of a blank white screen. Keyed by route
// in App.tsx so navigating away resets it.
interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error): void {
    console.error('[admin] page crashed:', error.message);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="container">
          <div className="card" style={{ padding: 24 }}>
            <h1 style={{ marginTop: 0 }}>Something went wrong on this page</h1>
            <p className="muted" style={{ margin: 0 }}>
              {this.state.error.message || 'Unexpected error.'}
            </p>
            <p className="muted" style={{ fontSize: 13, marginBottom: 0 }}>
              Try reloading, or pick another section from the nav above.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
